export default {
    path: '/appCapabilitiesList',
    auth: false,
    preload: false,
    isStatic: true,
    key: 'appCapabilitiesList',
    layout: 'inner', // outer 一级菜单 inner 二级菜单
    component: () => import('./index')
  };
  